
            const data = {"name":"icon-minus-medium","data":{"width":"32","height":"32","viewBox":"0 0 32 32","data":"<path pid=\"0\" _fill=\"currentColor\" d=\"M1.8 17a1 1 0 010-2h28.4a1 1 0 010 2H1.8z\"/>"}}
        
                module.exports = data
                